import { styled } from '@mui/material/styles';
import Link from 'components/Link';

export const MenuContainer = styled('div')(() => ({}));

export const Anchor = styled('div')(() => ({
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column'
}));

export const ManagerImage = styled('img')(({ theme }) => ({
  margin: `${theme.spacing(0.75)} 0`
}));

export const AccountLink = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: theme.spacing(0, 3)
}));

export const ManagerName = styled('div')(({ theme }) => ({
  color: theme.color.primary.main
}));

export const ManagerContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  margin: theme.spacing(1.5, 3, 1.5, 3),
  width: '230px',
  [`& ${ManagerImage}`]: {
    flexShrink: 0
  }
}));

export const ListItem = styled('div')(({ theme }) => ({
  alignItems: 'center',
  bottom: '0px',
  color: theme.color.default.main,
  display: 'flex',
  margin: '0px',
  position: 'absolute',
  top: '0px',
  width: '100%'
}));

export const LogoutListItem = styled(ListItem)(({ theme }) => ({
  textTransform: 'uppercase',
  justifyContent: 'center',
  paddingTop: theme.spacing(1.5)
}));
